











































import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {LongueursVente} from '@/models';

import storeLongueursVente from '@/stores/modules/longueursVente';

import InputDatePicker from '@/components/Input/DatePicker.vue';
import CrudFournisseurSearch from '@/components/Crud/Fournisseur/Search.vue';

@Component({
	components: {
		InputDatePicker,
		CrudFournisseurSearch,
	}
})
export default class CrudLongueursVenteEdit extends AbstractEditVue<LongueursVente> {
	public constructor() {
		super(
			storeLongueursVente,
			'Longueur de vente modifié',
			'Longueur de vente créé',
		);
	}
}
